import { v4 as uuidv4 } from 'uuid';
import { getCancellationServiceApiUrl } from '../selectors/selectors';
import { APPLICATION_JSON, CLIENT_ID, HOTEL } from '../constants/constants';

export default {
  fetch: ({
    type,
    locale,
    channel,
    body,
    envConfig,
    correlationId,
  }, action, state) => ({
    url: `${getCancellationServiceApiUrl(state)}/${type?.toLowerCase()}/policy`,
    opts: {
      method: 'POST',
      timeout: type?.toLowerCase() === HOTEL ? 35e3 : 30e3,
      credentials: 'include',
      headers: {
        'Content-Type': APPLICATION_JSON,
        'x-client-id': CLIENT_ID,
        'x-correlation-id': correlationId || uuidv4(),
        'x-locale': locale,
        'x-user-agent': window.navigator.userAgent,
        'x-channel': channel,
        'x-timestamp': new Date().toISOString(),
        'x-tulips-env': envConfig?.['x-tulips-env'],
        ...envConfig?.['x-expediarapid-env'] && type?.toLowerCase() === HOTEL && {
          'x-expediarapid-env': envConfig?.['x-expediarapid-env'],
        },
      },
      body,
    },
  }),
};
